<template>
    <transition appear name="fade-transition">
        <app-wysiwyg
            v-if="!raw"
            v-model="inputValue"
            :editable="false"
            :class="{ 'pb-0': form }"
            @validate="$emit('validate', $event)"
        />
        <template v-else>
            <span>{{ inputValue }}</span>
        </template>
    </transition>
</template>

<script>
import Display from './Display';
import tipTapToText from '@/lib/helpers/tipTapToText';

export default {
    name: 'DisplayContent',
    components: {
        AppWysiwyg: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppWysiwyg'
            )
    },
    extends: Display,
    props: {
        form: {
            type: Boolean,
            default: false
        },
        raw: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        inputValue: {
            get() {
                if (this.raw) {
                    return tipTapToText(this.value);
                }

                return this.value ? this.value : '';
            },
            set(v) {
                this.$emit('input', v);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.display__content {
    min-width: 10rem;
}
</style>
